import { createAsyncThunk } from "@reduxjs/toolkit";
import { addLeadPurposeApi, addLeadSourceApi, addLeadStatusApi, assignLeadApi, checkLeadPhoneApi, createLeadApi, deleteLeadApi, fetchLeadPurposeApi, fetchLeadsApi, fetchLeadSourceApi, fetchLeadStatusApi, leadActionApi, updateLeadApi } from "../../../apiservice/crm";

export const fetchLeads = createAsyncThunk(
  "leads/fetchLeads",
  async (filters = {}, { rejectWithValue }) => {
    try {
      const res = await fetchLeadsApi(filters);
      
      return (res.data || [])
      .filter(Boolean) // ✅ removes null/undefined
      .map((row, index) => ({
        id: row.id,
        no: index + 1,
        name: row.name,
        phone: row.phone,
        country: row.country,
        email: row.email,
        company: row.company,
        address: row.address,
        custom_fields:row.custom_fields,
        status: {
          name: row.status.name,
          label: row.status.label,
          color: row.status.color,
        },
        status_id: row.status_id,
        source: row.source,
        source_id: row.source_id,
        purpose: row.purpose,
        purpose_id: row.purpose_id,
        assigned_to: row.assigned_to,
        agent_name: row.agent_name,
        date: row.created_date,
        last_updated: row.last_updated,
      }));
    } catch (err) {
      return rejectWithValue(err.message);
    }
  }
);

export const updateLeadStatus = createAsyncThunk(
  "leads/updateStatus",
  async ({ id, action, source, dealValue, followUpDate, }, { rejectWithValue }) => {
    try {
      await leadActionApi({ id, action, source, dealValue,
        followUpDate, });
      return { id, action };
    } catch (err) {
      return rejectWithValue(err.message);
    }
  }
);
export const createLead = createAsyncThunk(
  "leads/createLead",
  async (payload, { rejectWithValue }) => {
    try {
      const res = await createLeadApi(payload);
      return res.data;
    } catch (err) {
      return rejectWithValue(
        err?.response?.data || {
          message: "Failed to create lead",
        }
      );
    }
  }
);

export const updateLead = createAsyncThunk(
  "leads/updateLead",
  async (payload, { rejectWithValue }) => {
    try {
      const res = await updateLeadApi(payload);
      return res.data;
    } catch (err) {
      return rejectWithValue(err.message);
    }
  }
);

export const checkLeadPhone = createAsyncThunk(
  "leads/checkPhone",
  async (payload, { rejectWithValue }) => {
    try {
      const res = await checkLeadPhoneApi(payload);
      return res.data;
    } catch (err) {
      return rejectWithValue(err.message);
    }
  }
);

export const assignLead = createAsyncThunk(
  "leads/assignLead",
  async (payload, { rejectWithValue }) => {
    try {
      await assignLeadApi(payload);
    } catch (err) {
      return rejectWithValue(err.message);
    }
  }
);

export const deleteLead = createAsyncThunk(
  "leads/deleteLead",
  async (id, { rejectWithValue }) => {
    try {
      await deleteLeadApi(id);
    } catch (err) {
      return rejectWithValue(
        err?.response?.data?.message || err.message
      );
    }
  }
);

export const fetchLeadStatus = createAsyncThunk(
  "leads/fetchLeadStatus",
  async (filters = {}, { rejectWithValue }) => {
    try {
      const res = await fetchLeadStatusApi(filters);     
      return (res.data || []) 
    } catch (err) {
      return rejectWithValue(err.message);
    }
  }
);
export const addLeadStatus = createAsyncThunk(
  "leads/addLeadStatus",
  async (payload, { rejectWithValue }) => {
    try {
      const res = await addLeadStatusApi(payload);
      return res.data;
    } catch (err) {
      return rejectWithValue(
        err?.response?.data?.message || err?.message || "Failed to add status"
      );
    }
  }
);
export const fetchLeadSource = createAsyncThunk(
  "leads/fetchLeadSource",
  async (filters = {}, { rejectWithValue }) => {
    try {
      const res = await fetchLeadSourceApi(filters);     
      return (res.data || []) 
    } catch (err) {
      return rejectWithValue(err.message);
    }
  }
);
export const addLeadSource = createAsyncThunk(
  "leads/addLeadSource",
  async (payload, { rejectWithValue }) => {
    try {
      const res = await addLeadSourceApi(payload);
      return res.data;
    } catch (err) {
      return rejectWithValue(
        err?.response?.data?.message || err?.message || "Failed to add source"
      );
    }
  }
);

export const fetchLeadPurpose = createAsyncThunk(
  "leads/fetchPurpose",
  async () => {
    const res = await fetchLeadPurposeApi();
    return res.data;
  }
);

export const addLeadPurpose = createAsyncThunk(
  "leads/addPurpose",
  async (data) => {
    const res = await addLeadPurposeApi(data);
    return res.data;
  }
);